



















































































































































































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { CustomerPortalBranding } from '@/api/model/customer-portal-branding'
import { CustomerPortalLink } from '@/api/model/customer-portal-link'
import { CustomerPortalLinkAPI } from '@/api/backend-client'

@Component
export default class EditCustomerPortalBrandingForm extends Vue {
    @Prop({ required: true }) readonly value!: CustomerPortalBranding
    customerPortalLink: CustomerPortalLink = null

    async mounted() {
        await this.loadData()
    }

    async loadData() {
        const result = await CustomerPortalLinkAPI.getPaged({company: this.$currentCompany.id, itemsPerPage: 1})
        if (result.collection.length > 0) {
            this.customerPortalLink = result.collection[0]
        }
    }

    get fontOptions() {
        return [
            'Open Sans',
            'Avenir',
            'Helvetica',
            'Arial',
            'Sans-serif',
        ].map(font => ({
            label: font,
            value: font,
        }))
    }

    get customerPortalLinkUrl() {
        if (!this.customerPortalLink) {
            return ''
        }
        return  `${ process.env.VUE_APP_KEYVUE_CUSTOMER_PORTAL_BASEURL }/${ this.customerPortalLink.id }?preview=1`
    }

    viewPreview() {
        const viewPreview = window.open(this.customerPortalLinkUrl)
        viewPreview.focus()
    }
}
